import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';

function FeedbackAction() {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };


  const handleInvite = () => {
    closeModal(); // Close the modal after handling the invite logic
  };

  const handleCancel = () => {
    console.log('Cancel button clicked');
    closeModal(); // Close the modal after handling the cancel logic
  };

//   const handleInputChange = (e) => {
//     onInputChange(e); // Use the onInputChange function from props
//    console.log("I m here....")
//   };


  return (
    <div>
    <button onClick={openModal}>Feedback</button>

      <FeedbackForm
        isOpen={isModalOpen}
        onClose={closeModal}
        onInvite={handleInvite}
        onCancel={handleCancel}
      />
      </div>
  );
}

export default FeedbackAction;
